export const phoneRegEx = /^([+]251(7|9)\d{8}$)|(0(7|9)\d{8}$)/
export const phoneRegExAll = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/
export const tinNumberRegEx = /^\d{6,15}$/

export const flexiblePhoneRegEx = /^(?:\+251[79]\d{8}|[79]\d{8}|0[79]\d{8})$/